import React, { useRef } from 'react'
import "./contact.css";
import {MdOutlineEmail} from 'react-icons/md';
import {RiMessengerLine} from 'react-icons/ri';
import {BsWhatsapp} from "react-icons/bs";
import emailjs from 'emailjs-com';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_vhtb3ib', 'template_zimhadu', form.current, 'JZ0M-cBx7AdHa8uCQ')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();

  };

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div class="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon"/>
            <h4>Email</h4>
            <h5>pasha49557@gmail.com</h5>
            <a href="mailto:pasha49557@gmail.com" target="_blank" rel="noreferrer">Send a Message</a>
          </article>
          <article className="contact__option">
            <RiMessengerLine className="contact__option-icon"/>
            <h4>Massenger</h4>
            <h5>Abdul Ahad</h5>
            <a href="https://m.me/100014973494321" target="_blank" rel="noreferrer">Send a Message</a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon"/>
            <h4>WhatsApp</h4>
            <h5>+92312472254</h5>
            <a href="https://api.whatsapp.com/send?phone=+923124722524" target="_blank" rel="noreferrer">Send a Message</a>
          </article>
        </div>
        {/* End OF Contact Option */}
        {/* For Forms We are going to use Email js for checking the message*/}
      <form ref={form} onSubmit={sendEmail}>
        <input type="text" name="name" placeholder="Your Full Name" required/>
        <input type="email" name="email" placeholder="Your Email" required/>
        <textarea name="message"  rows="7" placeholder="Your Message" required></textarea>
        <button type="submit" className="btn btn-primary">Send Message</button>
      </form>
      </div>

    </section>
  )
}

export default Contact